import { render, staticRenderFns } from "./indexFeeSummary.vue?vue&type=template&id=689bd696&scoped=true"
import script from "./indexFeeSummary.vue?vue&type=script&lang=js"
export * from "./indexFeeSummary.vue?vue&type=script&lang=js"
import style0 from "./indexFeeSummary.vue?vue&type=style&index=0&id=689bd696&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "689bd696",
  null
  
)

export default component.exports